import React from "react"
import styled from "@emotion/styled"
import HomepageBanner from "components/Homepage/homepageBanner"
import WhatsNew from "components/Homepage/whatsNew"
import LearnMore from "components/Homepage/learnMore"
import WhyUs from "components/Homepage/whyUs"
import Resources from "components/Homepage/resources"
import PathWays from "components/Homepage/pathWays"
import OurCompany from "components/Homepage/ourCompany"
import { graphql, useStaticQuery } from "gatsby"

const PageWrapper = styled.div`
    position: relative;
    color: #ffffff;
    & .caption-box-topbanner {
        text-shadow: rgb(0, 0, 0, 0.6) 2px 2px 5px;
    }
    & h1 {
        font-size: 80px;
    }
    & h2 {
        font-size: 60px;
    }
    & h2.header-title {
        border-left: ${(props) => props.theme.colors.primary} double;
        border-width: 4px 4px 0 4px;
        box-shadow: -3px 0 0 0 ${(props) => props.theme.colors.primary};
        padding-left: 0.5rem;
        line-height: 0.75;
        margin-left: -1.2rem;
        font-weight: normal;
        margin-bottom: 1rem;
    }
    @media (max-width: ${(props) => props.theme.breakpoints[6]}) {
        & h1 {
            font-size: 60px;
        }
    }
    @media (max-width: ${(props) => props.theme.breakpoints[4]}) {
        & h1 {
            font-size: 45px;
        }
        & h2 {
            font-size: 40px;
        }
    }
    @media (max-width: ${(props) => props.theme.breakpoints[3]}) {
        & h1 {
            font-size: 35px;
        }
        & h2 {
            font-size: 30px;
        }
    }
    @media (max-width: ${(props) => props.theme.breakpoints[2]}) {
        & h1 {
            font-size: 30px;
        }
        & h2 {
            font-size: 23px;
        }
    }
    @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
        & h1 {
            font-size: 20px;
        }
    }
`

const query = graphql`
    {
        banner: strapiPage(
            slug: { eq: "eip-homepage" }
            company: { shortname: { eq: "EIP" } }
        ) {
            title
            menu_title
            description
            metadata {
                description
                title
                OG_type
                OG_image {
                    publicURL
                    name
                    childImageSharp {
                        resize(width: 1200, height: 630, cropFocus: CENTER) {
                            src
                        }
                    }
                }
            }
            content {
                title
                Banner_Header_1
                Banner_Header_2
            }
            image {
                childImageSharp {
                    gatsbyImageData(placeholder: BLURRED)
                }
            }
        }
        pageContent: allStrapiPage(filter: { slug: { eq: "eip-homepage" } }) {
            edges {
                node {
                    content {
                        Single_Column {
                            title
                            content
                        }
                        Multi_Columns {
                            content
                            title
                        }
                    }
                }
            }
        }
        programmes: allStrapiPost(
            filter: { category: { slug: { eq: "programmes-and-events" } } }
            sort: { fields: createdAt, order: DESC }
            limit: 3
        ) {
            edges {
                node {
                    id
                    createdAt
                    title
                    image {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: BLURRED
                                height: 300
                                width: 640
                            )
                        }
                    }
                }
            }
        }
        promotions: allStrapiPost(
            sort: { fields: createdAt, order: DESC }
            limit: 3
            filter: { Post_Type: { eq: "Promotions" } }
        ) {
            edges {
                node {
                    id
                    createdAt
                    title
                    image {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: BLURRED
                                height: 300
                                width: 640
                            )
                        }
                    }
                }
            }
        }
        resources: allStrapiArticle(
            sort: { fields: published_date, order: DESC }
            filter: {
                category: { slug: { eq: "resources" } }
                Post_Type: { eq: "Blog_Post" }
            }
            limit: 3
        ) {
            edges {
                node {
                    summary
                    Description
                    category {
                        name
                        slug
                    }
                    menu_title
                    slug
                    title
                    image {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: DOMINANT_COLOR
                                width: 400
                                height: 400
                            )
                        }
                    }
                    author {
                        name
                    }
                    tags {
                        name
                        slug
                    }
                    published_date
                }
            }
        }
    }
`

// markup
const IndexPage = () => {
    const data = useStaticQuery(query)
    const { banner, promotions, programmes, pageContent, resources } = data
    const bannerContent = banner.content[0]
    const dataWhatsnew = [{ ...promotions }, { ...programmes }]
    let whatNewsDesc,
        academicDesc,
        resourcesDesc,
        companyDesc,
        whyUsDesc,
        whyUsData = null

    pageContent.edges[0].node.content.map((page, index) => {
        if (page.Single_Column !== null) {
            const title = page.Single_Column.title.toLowerCase()
            if (title.includes("whats")) {
                whatNewsDesc = page.Single_Column.content
            } else if (title.includes("academic")) {
                academicDesc = page.Single_Column.content
            } else if (title.includes("resource")) {
                resourcesDesc = page.Single_Column.content
            } else if (title.includes("company")) {
                companyDesc = page.Single_Column.content
            } else if (title.includes("why")) {
                whyUsDesc = page.Single_Column.content
            }
        } else if (page.Multi_Columns !== null) {
            whyUsData = page.Multi_Columns
        }
        return null
    })

    const bannerObj = {
        subtitle: bannerContent.Banner_Header_1,
        title: bannerContent.Banner_Header_2,
        imageFile: banner.image,
        homepage: true,
        banner_background_color:
            "linear-gradient(90deg, #e6fbff 25%, #f5fdff 25%, #f5fdff 50%, #e6fbff 50%, #e6fbff 75%, #f5fdff 75%, #f5fdff 100%)",
        description: banner.description,
    }
    return (
        <PageWrapper>
            <HomepageBanner data={bannerObj} />
            <WhatsNew data={dataWhatsnew} description={whatNewsDesc} />
            <LearnMore data={data} />
            <WhyUs data={whyUsData} description={whyUsDesc} />
            <Resources data={resources} description={resourcesDesc} />
            <PathWays description={academicDesc} />
            <OurCompany description={companyDesc} />
        </PageWrapper>
    )
}

export default IndexPage
